import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Rasppi } from './rasppi';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { RasppiType } from '../types';

const _schema = {
    "name": "SCALE",
    "fields": [
        { name: "rasppi", type: "objid" },
        { name: "status", type: "string", default: "AC" },
        { name: "name", type: "string" },
        { name: "model", type: "string" },
        { name: "port", type: "string" }
    ],
    relate: [
        { direction: ">", target: "RASPPI", by: "scales", name: "rasppi", reason: "rasppi", child: false, class: RasppiType },
    ]
} as const;

const _ScaleClass = CreateObject(_schema);
if (!_ScaleClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class ScaleDevice extends _ScaleClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): ScaleDevice {
        return this._Copy(store) as ScaleDevice;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'scales' && related instanceof Rasppi){
            if (related === this.rasppi){
                related.AddScale(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.rasppi){
            if ((this.status == 'DE') && !this.Commited){
                this.rasppi.DelScale(this);
            }
            else {
                this.rasppi.DoRefresh(this.table);
            }
        }
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
